import React from "react";
import { useSelector } from 'react-redux';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import LocalizedLink from 'helpers/LocalizeLink';
import { convert } from 'helpers/util';
import logo from 'assets/img/logo.svg';

const LearningMostWanted = (props) => {
    const auth = useSelector(store => store.auth);
    const { t } = useTranslation();
    const currentDate = new Date().getMonth();

    const getPublish = (trending) => {
        let publishDate = new Date(trending.updated_at).getMonth()

        return (publishDate > currentDate) ? 12 - publishDate + currentDate : currentDate - publishDate
    }

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 1.75,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 1.5,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1.25,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ],
    }

    return (
        <div>
            <p>{t('labels.most_wanted')}</p>
            <div>
                <div {...settings}>
                    {props.items.map((course, index) => {
                        return (
                            <div key={'lmw_' + index}>
                                <div>
                                    {
                                        course.img ?
                                            <img alt={'learning'} src={course.img} /> :
                                            <img alt={'learning'} src={logo} />
                                    }
                                    <LocalizedLink to={'learning/' + course.id}>
                                        <div>
                                            <div>
                                                {
                                                    !auth ?
                                                        <p>{t('labels.lock')}</p>
                                                        :
                                                        <p>{t('labels.learn')}</p>
                                                }
                                                <p></p>
                                            </div>
                                            <div>
                                                <span>{course.category}</span>
                                                <span>{t('filter.labels.difficulty')}: <span
                                                    className={'' + course.level}></span>
                                                </span>
                                            </div>
                                        </div>
                                    </LocalizedLink>
                                </div>
                                <div>
                                    <span>{course.title}</span>
                                    <div>
                                        <span>
                                            {convert((course.views > 0) ? course.views : 0)} {t('labels.view', { count: (course.views > 0) ? course.views : 0 })}
                                        </span>
                                        {" · "}
                                        <span>
                                            {getPublish(course)} {t('labels.month_ago', { count: getPublish(course) })}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </div>
    )
}

LearningMostWanted.propTypes = {
    title: PropTypes.string,
    descriptions: PropTypes.string,
    additional_text: PropTypes.string,
    button_text: PropTypes.string,
    path: PropTypes.string,
    img: PropTypes.string,
    position: PropTypes.number,
    widget: PropTypes.string,
    difficulty: PropTypes.string,
    className: PropTypes.string,
    items: PropTypes.array,
};

export default LearningMostWanted;